import { GameWrapper, GoogleAdsLeftBox, GoogleAdsRightBox, WebGlWrapper } from "./WebGLScreenStyled";
import { useEffect } from "react";
import { Box } from "components/Box";
import { GoogleAdsenseLeft } from "../GoogleAdsense/LeftSideCode/GoogleAdsenseLeft";
import { GoogleAdsenseRight } from "../GoogleAdsense/RightSideCode/GoogleAdsenseRight";

const WebGLScreen: React.FC = () => {

    useEffect(
        () => {
            var buildUrl = "./WEBGLplugin/CryptoTiles";
            var loaderUrl = buildUrl + "/CryptoTiles.loader.js";
            var config = {
                dataUrl: buildUrl + "/CryptoTiles.data",
                frameworkUrl: buildUrl + "/CryptoTiles.framework.js",
                codeUrl: buildUrl + "/CryptoTiles.asm.js",
                memoryUrl: buildUrl + "/CryptoTiles.mem",
                streamingAssetsUrl: "StreamingAssets",
                companyName: "gamefi",
                productName: "Crypto Tiles: Earn Real Bitcoin",
                productVersion: "1.0",
                devicePixelRatio: 1,
            };

            var container = document.querySelector("#unity-container") as HTMLCanvasElement;
            var canvas = document.querySelector("#unity-canvas") as HTMLCanvasElement;
            var loadingBar = document.querySelector("#unity-loading-bar") as HTMLDivElement;
            var progressBarFull = document.querySelector("#unity-progress-bar-full") as HTMLDivElement;
            var fullscreenButton = document.querySelector("#unity-fullscreen-button") as HTMLButtonElement;
            // var mobileWarning = document.querySelector("#unity-mobile-warning") as HTMLDivElement;

            if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
                container.className = "unity-mobile";
                config.devicePixelRatio = 1;
                // mobileWarning.style.display = "block";
                // setTimeout(() => {
                //     mobileWarning.style.display = "none";
                // }, 5000);
            } else {
                canvas.style.height = "90vh";
                canvas.style.width = "50vh";
                canvas.style.border = "10px solid rgb(205,99,255,0.1)";
            }
            loadingBar.style.display = "block";

            var script = document.createElement("script");
            script.src = loaderUrl;
            script.onload = () => {
                // @ts-ignore
                createUnityInstance(canvas, config, (progress) => {
                    progressBarFull.style.width = 100 * progress + "%";
                })
                    .then((unityInstance) => {
                        loadingBar.style.display = "none";
                        fullscreenButton.onclick = () => {
                            unityInstance.SetFullscreen(1);
                        };
                    })
                    .catch((message) => {
                        alert(message);
                    });
            };
            document.body.appendChild(script);
        }, []
    )

    return (
        <GameWrapper>
            <GoogleAdsLeftBox>

                {/* GoogleAdsense Component Call. */}
                <GoogleAdsenseLeft />

            </GoogleAdsLeftBox>
            <Box>
                <WebGlWrapper>
                    <div id="unity-container" className="unity-desktop">
                        <canvas id="unity-canvas"></canvas>
                        <div id="unity-loading-bar">
                            <div id="unity-logo"></div>
                            <div id="loading-text">Loading Game...</div>
                            <div id="unity-progress-bar-empty">
                                <div id="unity-progress-bar-full"></div>
                            </div>
                        </div>
                        <div id="unity-footer">
                            {/* <div id="unity-webgl-logo"></div> */}
                            <div id="unity-fullscreen-button"></div>
                            {/* <div id="unity-build-title">Crypto Tiles: Earn Real Bitcoin</div> */}
                        </div>
                    </div>
                </WebGlWrapper>
            </Box>
            <GoogleAdsRightBox>

                {/* GoogleAdsense Component Call. */}
                <GoogleAdsenseRight />

            </GoogleAdsRightBox>
        </GameWrapper>
    )
};

export default WebGLScreen;